export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Final2_01.41344e3b.jpg";